import { createFileRoute } from '@tanstack/react-router';
import { ItemPage, lerBuscaItens } from '@/components/item-cadastro';

export const Route = createFileRoute('/_app/cadastros/itens/novo')({
  validateSearch: (bruto: Record<string, unknown>) => lerBuscaItens(bruto),
  component: NovoRota,
});

function NovoRota() {
  return <ItemPage busca={Route.useSearch()} />;
}
